// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1aQMF","link":"styles_link__Kx9py","name":"styles_name__hrAn-","menu":"styles_menu__zjsKX","myAccount":"styles_myAccount__oAy7n"};